import React from "react";
import tw from "tailwind-styled-components";
import { MdClose, MdDelete } from "react-icons/md";
import moment from "moment";
import { ScrollableContent } from "../../Styles/InputStyles";
import { getModeName } from "../../../helpers";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const RecurringView = ({
  setIsViewExpense,
  selectedData,
  setIsEditExpense,
  setIsDeleteExpense,
  setPropId,
  filter,
  setIsEditRecurringExpense
}) => {
  const property = selectedData?.propertyList?.[0] || {};
  React.useEffect(() => {
    if (property?.id) {
      setPropId(property.id);
    }
  }, [property, setPropId]);

  const onClose = () => {
    setIsViewExpense(false);
  };

  const handleDeleteExpense = () => {
    setIsDeleteExpense(true);
    if (property?.id) {
      setPropId(property.id);
    }
    // setPropId(property?.id);
  };

  const getStatusBadge = (status) => {
    const statusStyles = {
      1: "bg-gray-200 text-gray-600 text-xs border-gray-100 border w-18 h-7 flex items-center justify-center rounded-full",
      2: "bg-gray-200 text-gray-600 text-xs border-gray-100 border w-18 h-7 flex items-center justify-center rounded-full",
    };

    const statusText = {
      1: "One Time",
      2: "Monthly",
    };

    return (
      <span
        className={`px-4 py-2 rounded-full text-xs font-semibold ${statusStyles[status] || "bg-gray-100 text-gray-800"
          }`}
      >
        {statusText[status] || "Not Assigned"}
      </span>
    );
  };

  return (
    <Container>
      <Header>
        <Title>Recurring Expense Details</Title>
        <button onClick={onClose}>
          <MdClose color="white" size={24} />
        </button>
      </Header>
      <ProfileSection className="flex justify-between">
        <UserInfo>
          <span className="font-medium mb-0">₹{selectedData?.amount}</span>
          <span className="text-sm text-gray-600">{selectedData?.name}</span>
        </UserInfo>
        <div className="flex gap-2">
          {filter !== "RE" &&
            <span>{getStatusBadge(selectedData?.repetitionType)}</span>}
          <MdDelete
            size={20}
            className="text-rose-500 cursor-pointer mt-1"
            title="Delete Expense"
            onClick={handleDeleteExpense}
          />
        </div>
      </ProfileSection>
      <Content>
        <ScrollableContent>
          <Wrapper>
            <BtnWrapper>
              <SectionTitle>Expense Details</SectionTitle>
              {filter !== "UM" &&
                <EditButton
                  title="Edit Basic Detail"
                  onClick={() => {
                    setIsViewExpense(false);
                    if (filter === "RE") {
                      setIsEditRecurringExpense(true);
                    } else {
                      setIsEditExpense(true);
                    }
                  }}
                >
                  Edit
                </EditButton>}
            </BtnWrapper>
            <Section>
              <Row>
                <FlexCol className="mb-0">
                  <Label>Amount Paid</Label>
                  <Value>₹{selectedData?.amount}</Value>
                </FlexCol>

                <FlexCol>
                  <Label>{(filter !== "RE" && filter !== "UM")
                    ? "Paid Date"
                    : "Due Date"}</Label>
                  <Value>
                    {(filter !== "RE" && filter !== "UM")
                      ? moment(selectedData?.paidDate).format("DD-MMM-YY")
                      : moment(selectedData?.dueDate).format("DD-MMM-YY")}
                  </Value>
                </FlexCol>
              </Row>
              <Row>
                <FlexCol>
                  <Label>Paid To</Label>
                  <Value>{selectedData?.paidToName}</Value>
                </FlexCol>
                <FlexCol className="mb-0">
                  <Label>Paid By</Label>
                  <Value>{selectedData?.paidByName}</Value>
                </FlexCol>
              </Row>
              <Row className="mb-3">
                <FlexCol>
                  <Label>Recurring After</Label>
                  <Value>
                    {selectedData?.noOfMonths + " Month/s"}
                  </Value>
                </FlexCol>
                {property?.name &&
                  <FlexCol>
                    <Label>Property</Label>
                    <Value>{property?.name}</Value>
                  </FlexCol>}
              </Row>
              {selectedData?.description &&
                <div>
                  <FlexCol>
                    <Label>Description</Label>
                    <Value>{selectedData?.description}</Value>
                  </FlexCol>
                </div>}
              <div className="flex justify-end">
                <FlexCol>
                  <Value className="text-blue-500 underline">
                    <Link
                      to={selectedData?.supportDoc}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {selectedData?.supportDoc?.split("/").pop()}
                    </Link>
                  </Value>
                </FlexCol>
              </div>
            </Section>
          </Wrapper>
        </ScrollableContent>
      </Content>
    </Container>
  );
};

const Header = tw.div`flex items-center justify-between bg-[#26A69A] py-4 px-4`;
const Wrapper = tw.div`grid gap-2 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Content = tw.div`p-4 flex flex-col gap-4`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-white`;
const Section = tw.div`border border-gray-200 p-2 rounded-lg mb-3`;
const SectionTitle = tw.h2`text-base font-medium text-gray-600 flex justify-between items-center`;
const Row = tw.div`grid grid-cols-2 py-1 md:p-1`;
const Label = tw.label`text-sm text-gray-400 font-normal`;
const Value = tw.span`text-gray-600 text-md`;
const BtnWrapper = tw.div`w-full flex items-center justify-between`;
const FlexCol = tw.div`flex flex-col gap-0.5`;
const UserInfo = tw.div`flex flex-col`;
const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 px-4 p-4`;
const EditButton = tw.button` text-sm px-1 py-0.5 items-center flex justify-between text-primary-color underline`;

export default RecurringView;